module.exports = __webpack_public_path__ + "b07750d34f9464a0d1bee07433ad72fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/wells_fargo_funds.png
// module id = 1536
// module chunks = 0